<template>
  <IconBtn ref="btn" @click="$emit('click')" :btnStyle="{'background-position': '-934px -314px','background-image': 'url(\'/static/img/icons.png\')'}" ></IconBtn>
</template>

<script>
    //@按钮
    import IconBtn from "../baseComponent/IconBtn.vue"
    export default {
        name: "AtBtn",
        components: {IconBtn},
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/iconBtn/AtBtn.vue